/* eslint-disable import/prefer-default-export */

/**
 * converts/maps service-agnostic render options to service-specific API params
 * using the provided API prop map.
 *
 * the keys of the API prop map are the service-agnostic names. simple value
 * mapping is accomplished using string values.
 *
 * for non-trivial mapping, a function is provided as the value. this function
 * accepts a simple value as the single argument and returns an object as the
 * result. this allows a single service-agnostic render option to be mapped to
 * multiple service-specific key/value pairs using custom logic, thereby
 * allowing us to adapt our service-agnostic render option to the
 * service-specific API.
 *
 * @export
 * @param {Object} [apiPropMap={}] key is service-agnostic prop name; value is either string or function
 * @param {Object} [options={}] service-agnostic render options
 * @returns {String} service-specific render options per provided mapping
 */
export function mapRenderOptions(apiPropMap = {}, options = {}) {
  const params = Object.entries(options).reduce((acc, [optKey, optValue]) => {
    // the mapping is either a simple value, a function, or undefined for an
    // unknown mapping.
    const mapping = apiPropMap[optKey];

    // bail if the passed value or the mapping is undefined. we don't want
    // undefined values in the URL; they are just excluded.
    if (optValue === undefined || mapping === undefined) {
      return acc;
    }

    const mappedValue =
      typeof mapping === 'function'
        ? mapping(optValue)
        : { [mapping]: optValue };

    return {
      ...acc,
      ...mappedValue
    };
  }, {});

  // return params formatted as query string params
  return params;
}
